import React from "react";
import { ButtonGroup } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { isSwapRouteEnabled } from "utils/helper";
import "./HeroSection.scss";
import { MyButton } from "components/button";

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="hero-section">
      <video
        poster={process.env.REACT_APP_S3_IMAGE_PATH + "vanar-hero-poster.jpg"}
        autoPlay
        loop
        muted
        playsInline
        className="grid"
      >
        <source
          src={process.env.REACT_APP_S3_IMAGE_PATH + "vanar-hero-vd.mp4"}
          type="video/mp4"
        />
      </video>

      <div className="hero-content">
        <div className="wrapper fadeInAnimation">
          <h2 className="fadeInAnimation">
            Begin Your Journey From $TVK to $VANRY!
          </h2>
          {/* <p className="fadeInAnimation">
            Stake $TVK Early in VANAR's Pre-Staking Event! Get exclusive $VANRY rewards on the launch of mainnet. The future awaits—join the revolution now!
          </p> */}
          <p className="fadeInAnimation">
            You can swap your $TVK to $VANRY ERC-20 now. Join the VANAR
            revolution now!
          </p>
          {/* <p className="fadeInAnimation">Join the VANAR revolution now!</p> */}

          <ButtonGroup>
            <MyButton
              className="custom-btn lg dark fadeInAnimation rounded"
              text="Swap TVK to VANRY"
              handleClick={() => isSwapRouteEnabled && navigate("/swap")}
            />
            {/* <button
              className={`custom-btn lg dark fadeInAnimation rounded ${
                !isSwapRouteEnabled ? "disabled" : ""
              }`}
              onClick={() => isSwapRouteEnabled && navigate("/swap")}
            >
              <span className="smallTag">Coming soon</span>
              <span>Swap TVK to VANRY</span>
            </button> */}
            <a
              type="button"
              className="custom-btn lg dark fadeInAnimation rounded"
              href={process.env.REACT_APP_STAKING_URL}
            >
              <span className="smallTag">Closed</span>
              <span>Stake & Earn</span>
            </a>
          </ButtonGroup>

          <div className="hero-caption">
            {/* <p className="date">
              This token swap portal will be open until{" "}
              <span className="green">1st December 2023.</span>
            </p> */}
            <p className="note mb-0">
              By connecting your wallet and participating you confirm that you
              have read and understood the
              <Link
                to="/disclaimer"
                rel="noopener noreferrer"
                className="green"
              >
                Terms & Conditions.
              </Link>
            </p>
          </div>
        </div>

        {/* <div className="hero-img-effect">
          <div className="mainCard">
            <Image
              src={process.env.REACT_APP_S3_IMAGE_PATH + "card.png"}
              alt="card"
              fluid
              className="cardImg fadeSlideUpAnimation"
            />
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default HeroSection;
